import { createRoot } from "react-dom/client";
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import '@gdk/full/dist/styles/gdk-full.min.css';
import '@gdk/navigation/dist/styles/gdk-navigation.min.css';
import SectionLoader from './components/sectionLoader';
import { PageLoadingContextProvider } from './contexts/PageLoadingContext';
import { ClientConfigContextProvider } from './contexts/ClientConfigContext';
import { AnalyticsContextProvider } from './contexts/AnalyticsContext';
import { Main } from "./Main";
import { AutoRedirectContextProvider } from "./contexts/AutoRedirectContext";
import { ConsolidatedSummaryProvider } from "./contexts/ConsolidatedSummaryContext";

function render() {
    const container = document.getElementById("root")!;
    const root = createRoot(container);

    root.render(
        <Provider store={store}>
            <PageLoadingContextProvider>
                <ClientConfigContextProvider>
                    <AutoRedirectContextProvider>
                        <AnalyticsContextProvider>
                            <SectionLoader />
                            <BrowserRouter>
                                <ConsolidatedSummaryProvider> 
                                    <Main />
                                </ConsolidatedSummaryProvider>
                            </BrowserRouter>
                        </AnalyticsContextProvider>
                    </AutoRedirectContextProvider>
                </ClientConfigContextProvider>
            </PageLoadingContextProvider>
        </Provider>
    );
}

render();